<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowPayrollRelatedPerNetRev',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'payroll_related_expenses', throughMonth),
          this.getYtdByField(yearObj, 'net_ha_revenue', throughMonth),
          0,
        );
      },
    },
  };
</script>
